export default [
    {
        name: 'base',
        data: {},
        items:
        [
            { name: 'iPhone', source: '/models/iPhone/iphone.glb' },
        ]
    }
]